import { ProductVariant } from '@/features/pos/components/ProductConfigurationModal/types'

export const getDefaultProductVariant = (
    productVariants?: ProductVariant[],
    defaultId?: string
): ProductVariant | undefined =>
    defaultId ? productVariants?.find(({ id }) => id === defaultId) : productVariants?.[0]
